import axiosInstance from "../../config/axios-config";

async function fetchData(url, setData, setCurrentdata, jwtToken) {
  try {
    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    const data = await response.data;
    setData(data);
    setCurrentdata(data.allStarCardModels);
  } catch (err) {
    console.error(err);
    setData(null);
  }
}

export { fetchData };
